import { createActionsForAppInstance } from '@nab/x-registries';
import { defaultActionsProvider } from './defaultActionsProvider';
const createActionsForApp = (app, instanceId) => {
    return createActionsForAppInstance(app, instanceId, defaultActionsProvider);
};
export { createActionsForApp };
//# sourceMappingURL=createActionsForApp.js.map